import { MorePage } from "../pages/more";

export const element = <MorePage />